<template>
    <v-checkbox
        :label="choice.value+' ('+organisationCount+')'"
        :value="choice.id"
        v-model="selectedChoices"
        multiple
        color="secondary"
        hide-details="auto"
    >
        <template v-slot:append>
            <v-tooltip v-if="getTooltipText(choice.id)" top>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        class="pl-2 mr-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        fa fa-info
                    </v-icon>
                </template>
                <span v-html="getTooltipText(choice.id)"></span>
            </v-tooltip>
        </template>
    </v-checkbox>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "FacetFilter",
    props: {
        facet: {
            type: Object,
            required: true,
        },
        choice: {
            type: Object,
            required: true,
        },
    },
    computed: {
        selectedChoices: {
            get () { return this.filters.facetChoices[this.facet.id]; },
            set (value) { this.$store.dispatch('organisation/updateFacetFilter', {facet: this.facet, choices: value}) },
        },
        organisationCount () {
            const choiceIds = this.choice.ids || [this.choice.id];
            return this.organisations.filter(organisation =>
                organisation.facetChoices.some(choice => choiceIds.includes(choice.id))
            ).length;
        },
        ...mapState({
            filters: state => state.organisation.filters,
            organisations: state => state.organisation.organisations,
        }),
    },
    methods: {
        getTooltipText(choiceId) {
            const tooltips = {
                49: '<strong>Hiermee wordt bedoeld:</strong><br>Het handhaven van discipline in de klas zoals orde houden, consequent handelen, vrijheid versus structuur.',
                50: '<strong>Hiermee wordt bedoeld:</strong><br>Denk hierbij bijvoorbeeld aan het vervullen van de opgedragen niet lesgebonden administratieve taken zoals het bijhouden van de diverse volgsystemen, de taken op het gebied van communicatie, de administratieve druk die voortvloeit uit vergaderingen, overdracht en afstemming en taakbeleid.',
                51: '<strong>Hiermee wordt bedoeld:</strong><br>Denk daarbij aan bijvoorbeeld: Op welke manieren kun je communiceren met ouders, hoe kan je omgaan met dwingend en dominant gedrag.<br>Hoe ga je om met onredelijkheid. Hoe bewaak je grenzen. Hoe blijf je in gesprek. Hoe houd je het zakelijk.',
                52: '<strong>Hiermee wordt bedoeld:</strong><br>Klassenmanagement is het geheel aan maatregelen, strategieën en vaardigheden die een leerkracht inzet om een gestructureerde, veilige en positieve leeromgeving te creëren, waarin leerlingen optimaal kunnen leren en ontwikkelen.<br>Het gaat hierbij niet alleen om regels en discipline, maar ook om de organisatie van de les, de inrichting van het lokaal, de relaties binnen de klas en de communicatie met leerlingen, om een effectieve en prettige sfeer te bevorderen.',
                53: '<strong>Hiermee wordt bedoeld:</strong><br>Timemanagement is het bewust organiseren, plannen en beheren van je tijd om efficiënter te werken, doelen te bereiken en stress te verminderen.<br>Het gaat hierbij om het stellen van prioriteiten, het maken van keuzes over je aandacht, en het aanpakken van afleidingen en uitstelgedrag.',
                54: '<strong>Hiermee wordt bedoeld:</strong><br>Denk hierbij aan begeleiding e/o trainingen op het gebied van duurzame inzetbaarheid, vitaliteit en energiebeheer om jezelf gezond en productief te houden.',
            };
            return tooltips[choiceId] || null;
        }
    },
}
</script>

<style scoped>

</style>
